export const AppConfig = {
  passStatus: {
    pending: 0,
    registered: 1,
    declined: 2,
    canceled: 3,
    used: 4,
    expired: 5,
    denied: 6,
    inactive: 7,
    checkedIn: 8,
    suspended: 9,
  },
  passType: {
    undefined: 0,
    employee: 1,
    family: 5,
    vip: 6,
    goldCard: 7,
    guest: 10,
    vendor: 20,
    comp: 30,
    elite: 40,
    affiliate: 50,
    staff_dress: 60,
    converse: 201,
    swoosh: 101,
    converse_family: 205,
    swoosh_family: 105,
  },
  policyLocationIds: {
    unknown: 0,
    argentina: 32,
    austria: 40,
    belgium: 56,
    canada: 124,
    chile: 152,
    china: 156,
    croatia: 191,
    czech: 203,
    denmark: 208,
    france: 250,
    germany: 276,
    hongKong: 344,
    hungary: 348,
    india: 356,
    indonesia: 360,
    ireland: 372,
    italy: 380,
    japan: 392,
    korea: 410,
    malaysia: 458,
    mexico: 484,
    netherlands: 528,
    norway: 578,
    philippines: 608,
    poland: 616,
    portugal: 620,
    russia: 643,
    singapore: 702,
    vietnam: 704,
    spain: 724,
    sweden: 752,
    switzerland: 756,
    taiwan: 158,
    thailand: 764,
    unitedkingdom: 826,
    unitedStates: 840,
  },
  privacyPolicyLinks: {
    32: 'http://agreementservice.svs.nike.com/ar/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=ar&language=es&requestType=redirect',
    124: 'http://agreementservice.svs.nike.com/ca/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=ca&language=en&requestType=redirect',
    152: 'http://agreementservice.svs.nike.com/cl/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=cl&language=es&requestType=redirect',
    156: 'https://agreementservice.svs.nike.com/cn/zh_cn/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.unite&country=CN&language=zh&requestType=redirect', // GC
    158: 'https://agreementservice.svs.nike.com/tw/zh_tw/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=TW&language=zh&requestType=redirect', // TW
    344: 'https://www.nike.com.hk/helpcenter/privacy_statement.htm', // HK
    392: 'http://agreementservice.svs.nike.com/jp/ja_jp/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=jp&language=ja&requestType=redirect',
    394: 'http://agreementservice.svs.nike.com/kr/ko_kr/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=kr&language=ko&requestType=redirect',
    446: 'https://agreementservice.svs.nike.com/tw/zh_tw/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.commerce.nikedotcom.web&country=TW&language=zh&requestType=redirect', // Macau
    484: 'http://agreementservice.svs.nike.com/mx/es_la/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=mx&language=la&requestType=redirect',
    840: 'http://agreementservice.svs.nike.com/us/en_us/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=us&language=en&requestType=redirect',
    360: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    458: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    608: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    702: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    704: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
    764: 'http://agreementservice.svs.nike.com/my/en_gb/rest/agreement?agreementType=privacyPolicy&uxId=com.nike.store.passplay&country=my&language=ms&requestType=redirect',
  },
  regexPatterns: {
    regexEmail: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    regexPersonNames: '^[^\\[\\]/#@=^,+()$~%:*`_?;|<>{}!\\\\]+$',
    regexOrgNames: '[^[]#=^,+()$~%:*`?;|<>{}\\\\]+',
    regexNumbers: '[0-9]+',
    regexMobile: /^\+(86)\d{11}$/,
  },
  validationMessages: {
    namesErrorMessage: "Sorry that character can't be used here",
    validEmailMessage: 'Please enter a valid email',
  },
  visitTypes: {
    undefined: 0,
    employee: 1,
    family: 5,
    vip: 6,
    goldCard: 7,
    guest: 10,
    vendor: 20,
    comp: 30,
    elite: 40,
    affiliate: 50,
    staff_dress: 60,
    converse: 201,
    swoosh: 101,
    converse_family: 205,
    swoosh_family: 105,
  },
  locales: {
    us: 'en-US',
    mexico: 'es-MX',
    japan: 'ja-JP',
    korea: 'ko-KR',
    china: 'zh-CN',
    czechrepublic: 'cz-CZ',
    denmark: 'dk-DK',
    france: 'fr-FR',
    germany: 'de-DE',
    greece: 'gr-GR',
    italy: 'it-IT',
    netherlands: 'nl-NL',
    poland: 'pl-PL',
    portugal: 'pt-PT',
    spain: 'es-ES',
    sweden: 'se-SE',
    uk: 'en-GB',
    austria: 'de-AT',
    ireland: 'en-IE',
    belgium: 'en-BE',
    luxembourg: 'en-LU',
  },
  emailFlags: {
    none: 0,
    optional: 1,
    required: 2,
    membership: 3,
    optin: 4,
  },
};
